import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/navigation.css';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <div className="navigation">
      {!isOpen && (
        <button className="menu-button" onClick={toggleMenu}>
          ☰
        </button>
      )}
      
      {isOpen && (
        <div className="menu-popup">
          <button className="menu-button inside-popup" onClick={toggleMenu}>
            ☰
          </button>
          
          <div className="menu">
            <Link to="/" onClick={toggleMenu}>Home</Link>
            <Link to="/about" onClick={toggleMenu}>About</Link>
            <Link to="/prices" onClick={toggleMenu}>Prices</Link>
            <Link to="/contact" onClick={toggleMenu}>Contact</Link>
            <Link to="/management" onClick={toggleMenu}>Management</Link>
            <Link to="/portfolio" onClick={toggleMenu}>Portfolio</Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navigation;